import { useCallback, useState } from 'react';

// O MENU DO PERFIL RECOLHIDO (só os ícones) ou aberto, lembrado neste navegador. É conveniência de
// quem usa (cada pessoa escolhe o seu), por isso mora no `localStorage`, e o acesso é protegido:
// numa janela privada ou com o armazenamento bloqueado, o menu só volta aberto.

const CHAVE = 'maestra:menu-recolhido';

const ler = () => {
  try { return window.localStorage.getItem(CHAVE) === '1'; } catch { return false; }
};

export const useMenuRecolhido = () => {
  const [recolhido, setRecolhido] = useState(ler);
  const alternar = useCallback(() => setRecolhido((atual) => {
    const novo = !atual;
    try { window.localStorage.setItem(CHAVE, novo ? '1' : '0'); } catch { /* fica só nesta visita */ }
    return novo;
  }), []);
  return { recolhido, alternar };
};
